import { branch, renderNothing } from 'recompose'
import { serviceSelector } from '../../selectors'

const withService = compose(
    connect(
        createStructuredSelector({
            service: serviceSelector,
        })
    ),
    branch(props => !props.service, renderNothing)
)

export default withService
